export const environment = {
  production: false,
  id: '4x',
  baseUrl: 'https://4x.superlikerslabs.com',
  photosPath: 'https://super-likers.s3.amazonaws.com/uploads/upload-photo'
}
